/* Mobile (demande d'Ed, oct. 2026) : toucher une photo fait la meme chose que la loupe : la galerie plein ecran
   s'ouvre sur la photo touchee. Un glissement pour changer de photo n'ouvre rien. Fleche retour, coeur et liens : inchanges. */
(function () {
  if (window.__mpnTapZoom) return; window.__mpnTapZoom = true;
  var sx = 0, sy = 0, moved = false;
  document.addEventListener('touchstart', function (e) { var t = e.touches[0]; if (!t) return; sx = t.clientX; sy = t.clientY; moved = false; }, { passive: true, capture: true });
  document.addEventListener('touchmove', function (e) { var t = e.touches[0]; if (t && (Math.abs(t.clientX - sx) > 10 || Math.abs(t.clientY - sy) > 10)) moved = true; }, { passive: true, capture: true });
  document.addEventListener('click', function (e) {
    if (!window.matchMedia('(max-width: 749.98px)').matches || moved) return;
    var c = e.target.closest && e.target.closest('media-gallery .product__media-list .product-media-container.media-type-image');
    if (!c) return;
    var bt = e.target.closest('a, button, .mpn-fav-btn, .mpn-pdp-back');
    if (bt && !bt.classList.contains('product__media-toggle')) return;
    var opener = c.querySelector('modal-opener[data-modal]');
    var toggle = c.querySelector('.product__media-toggle[data-media-id]');
    var m = opener && document.querySelector(opener.getAttribute('data-modal'));
    if (!m || typeof m.show !== 'function' || !toggle) return;
    e.preventDefault(); e.stopPropagation();
    m.show(toggle);
  }, true);
})();
